module.exports = __webpack_public_path__ + "static/media/empty_preview.82a33a43.png";